import { articleChecks } from '../content/ArticleWorkflow';
import { checkRows, itemRows } from '../reach/voiceWords';
import type { HistoryData } from './historyWords';

/**
 * The checks on what's waiting, beside History's Approve, in the side panel's
 * words so the two can't disagree (backlog cbeee8ec). Anything that stops the
 * approval sends the person to Checks or the post, the one place with a reason
 * and the owner rule; the server refuses either way.
 */

export interface WaitingChecks {
  rows: { icon: string; color: string; text: string; sev: string }[];
  blocked: boolean;
  held: boolean;
}

export function waitingChecks(data: HistoryData): WaitingChecks {
  const c = data.checks;
  if (!c) return { rows: [], blocked: false, held: false };
  if (data.kind === 'post') {
    const items = c.items ? itemRows(c.items).filter((r) => r.sev !== 'Approved anyway') : [];
    const voice = c.voice?.state === 'findings' && !c.voice.kept ? checkRows(c.voice) : [];
    return {
      rows: [...items, ...voice],
      blocked: Boolean(c.items?.holds || c.voice?.holds),
      held: Boolean(c.items?.holds),
    };
  }
  const { rows, blocking } = articleChecks({
    preflight: c.preflight || [],
    copyEdit: c.copyEdit || undefined,
  } as Parameters<typeof articleChecks>[0]);
  return {
    // As the publish card has them: suggestions stay under Checks.
    rows: rows.filter(
      (r) => r.held || r.sev === 'Blocking' || (r.sev === 'Warning' && !r.suggestion)
    ),
    blocked: blocking > 0,
    held: rows.some((r) => r.held),
  };
}

/** Why Approve isn't here, and where it is. */
export function blockedNote(checks: WaitingChecks, data: HistoryData) {
  if (data.kind === 'post') {
    if (data.status !== 'waiting') {
      return 'It can’t go out as it is. Edit the post, or restore a different version.';
    }
    return checks.held
      ? 'Fix it in the post, or an owner or admin can approve it there with a reason.'
      : 'Fix it in the post before approving it.';
  }
  return checks.held
    ? 'Fix these under Checks, or an owner or admin can approve it there with a reason.'
    : 'Fix these under Checks, or approve it there with a reason. The reason is recorded with your approval.';
}
